<div class="zero-column-wrap">
    <div [id]="entity().id" [attr.data-raw-id]="entity().id" class="column">
        @if (showColumnHorizontalCenter()) {
            <div class="column-center-guide column-center-guide-vertical"></div>
        }
        @if (showColumnVerticalCenter()) {
            <div class="column-center-guide column-center-guide-horizontal"></div>
        }
        @for (widget of widgets(); track widget.id; let i = $index) {
            @let widgetErrors = widgetErrorsById(widget.id);

            <web-zero-signal-widget
                [index]="i"
                [widget]="widget"
                [column]="entity()"
                [gridId]="widget?.structureId"
                [blockId]="blockId()"
                [widgetErrors]="widgetErrors"
                [isTablet]="isTablet()"
                [isMobile]="isMobile()"
            />
        }
    </div>
</div>
